<template>
  <div>
    <div :class="data.class" class="checkbox">
      <span>{{ data.props.defaultValue ? "✔️" : "⬜" }} {{ data.label }}</span>
      <footnotes v-if="data.props.footnotes" :all-footnotes="footnotes" :local-footnotes="data.props.footnotes"></footnotes>
      <br v-if="data.props.url">
      <a v-if="data.props.url" :href="data.props.url">{{ data.props.urlLabel }}</a>
      <br v-if="data.props.caption">
      <span v-if="data.props.caption" class="caption" style="margin-top: 10px">{{ data.props.caption }}</span>
    </div>
  </div>
</template>

<script>
import Footnotes
  from "./Footnotes.vue"

export default {
  name: 'CHECKBOX',
  components: {Footnotes},
  props: ['data', 'footnotes'],
}
</script>



// WEBPACK FOOTER //
// CHECKBOX.vue?0b76ad6b